import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CallAction from '../components/CallAction';

const HelpCenter = () => {

  const [apiData, setApiData] = useState([]); 

  useEffect(() => {
    // Fetch data from the API
    fetch('https://dayoffice24.it/api/help-center')
      .then((response) => response.json())
      .then((data) => {
        if (data.success && data.data) {
          setApiData(data.data);
        }
      })
      .catch((error) => {
        console.error('Error fetching data from API:', error);
      });
  }, []);

  return (
     
   <div className="main_wrap">   

     <Header />

     <div className="content-wrapper"> 

            <div className="breadcrumb-wrap bg-f br-2"> 
               <div className="container">
                  <div className="breadcrumb-title text-center">
                     <h2>How can we help you today</h2>
                     <p>Proin gravida nibh vel velit auctor aliquet aenean sollicitudin lorem quis bibendum auctor  nisi elit consequat ipsum nec sagittis sem nibh id elit.</p>
                     <form action="#" className="search-form help_center_form"> 
                        <input type="text" placeholder="Search..." />
                        <i className="flaticon-search"></i>
                        <button type="submit">Search</button> 
                     </form>
                  </div>
               </div>
            </div>

           <section className="faq-wrap style4 ptb-100 support_data">
            <div className="container">
              <div className="row justify-content-center">
                {apiData.map((item) => (
                  <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6" key={item.id}>
                    <div className="adv-card">
                      <div className="adv-img">
                        <img src={item.photo} alt="Image" />
                      </div>
                      <div className="adv-info">
                        <Link to={`/HelpCenterView/${item._id}`}>
                          <h3>{item.title}</h3>
                        </Link>
                        <p>{item.short_desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

         <CallAction />

     </div>

     <Footer />  

    </div>

  );
};

export default HelpCenter;
